import { render, staticRenderFns } from "./AddVkAdds.vue?vue&type=template&id=a20264aa&scoped=true"
import script from "./AddVkAdds.vue?vue&type=script&lang=js"
export * from "./AddVkAdds.vue?vue&type=script&lang=js"
import style0 from "./AddVkAdds.vue?vue&type=style&index=0&id=a20264aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20264aa",
  null
  
)

export default component.exports